module.exports = __webpack_public_path__ + "img/info_logo.04665d79.png";